import * as React from 'react';
import { Typography, Link } from '@mui/material';

export function Copyright(props: any) {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    >
      {'Copyright © '}
      <Link color="inherit" href="https://github.com/jty016">
        MDSouth
      </Link>{' '}
      {new Date().getFullYear()}.
    </Typography>
  );
}
